/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

//mmx-feature --start
/*
import { ITextBlockViewProps } from '@msdyn365-commerce-modules/text-block';
*/
import { ITextBlockViewProps as IMSTextBlockViewProps } from '@msdyn365-commerce-modules/text-block';
import { ITextBlockProps as ITextBlockExtProps } from '../definition-extensions/text-block.ext.props.autogenerated';

interface ITextBlockViewProps extends IMSTextBlockViewProps, ITextBlockExtProps<{}> {
    config: IMSTextBlockViewProps['config'] & ITextBlockExtProps<{}>['config'];
}
//mmx-feature --end

const TextBlockView: React.FC<ITextBlockViewProps> = props => (
    <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
        {props.paragraph}
    </div>
);

export default TextBlockView;
